/*
 * Filtri su mobile («Filtra e ordina», snippets/facets.liquid).
 * In Trade i sottopannelli dei filtri (Materiale, Funzionalità…) stanno dentro l'elenco
 * scorrevole .mobile-facets__main con top: 0, cioè in cima al contenuto dell'elenco e non
 * alla parte visibile. Trade si affida al focus sul pulsante «indietro» per riportare
 * l'elenco in cima, ma sui telefoni non succede: se l'elenco era stato fatto scorrere, il
 * sottopannello si apriva fuori vista e compariva sfalsato scorrendo (segnalazione del 16/10).
 * Qui il sottopannello si apre sulla parte visibile e l'elenco resta fermo finché è aperto.
 */
if (!window.gmFiltriMobile) {
  window.gmFiltriMobile = true;

  // In cattura: prima del gestore di Trade, che apre il sottopannello 100 ms dopo il clic.
  document.addEventListener(
    'click',
    (evento) => {
      const summary = evento.target.closest('.mobile-facets__details > summary');
      if (!summary) return;
      const dettagli = summary.parentElement;
      const elenco = dettagli.closest('.mobile-facets__main');
      const pannello = summary.nextElementSibling;
      if (!elenco || !pannello || dettagli.hasAttribute('open')) return;

      pannello.style.top = `${elenco.scrollTop}px`;
      pannello.style.bottom = 'auto';
      pannello.style.height = `${elenco.clientHeight}px`;
      elenco.style.overflowY = 'hidden';
    },
    true
  );

  // «toggle» non risale: si ascolta in cattura. Alla chiusura (anche del cassetto intero)
  // il sottopannello torna come lo vuole Trade e l'elenco riprende a scorrere.
  document.addEventListener(
    'toggle',
    (evento) => {
      const dettagli = evento.target;
      if (!(dettagli instanceof HTMLDetailsElement) || dettagli.open) return;
      if (!dettagli.classList.contains('mobile-facets__details')) return;
      const pannello = dettagli.querySelector(':scope > .mobile-facets__submenu');
      if (pannello) ['top', 'bottom', 'height'].forEach((p) => pannello.style.removeProperty(p));
      const elenco = dettagli.closest('.mobile-facets__main');
      if (elenco && !elenco.querySelector('.mobile-facets__details[open]')) elenco.style.removeProperty('overflow-y');
    },
    true
  );
}
